module.exports = __webpack_public_path__ + "media/images/front/top/dplus_20241009-c09b06d76b2d143a7155bd236e20c984.jpg";